const getPpsUrl = (ppsUrl) => {
	if (!ppsUrl) {
		return null;
	}
	if (typeof ppsUrl === "object") {
		ppsUrl = ppsUrl.url;
	}
	if (typeof ppsUrl !== "string") {
		return null;
	}
	const trimmed = ppsUrl.trim();
	if (!/^https?:\/\//i.test(trimmed)) {
		return null;
	}
	return trimmed;
};

export default getPpsUrl;



/** WEBPACK FOOTER **
 ** ./src/modules/common/ppsUrl.js
 **/